/**
 *   Checks if date is affected by daylight saving time.
 */
export function hasDST(date = new Date()) {
	const january = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
	const july = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();

	return Math.max(january, july) !== date.getTimezoneOffset();
}

/**
 *   Checks if a supplied (and implied) epoch number is indeed a valid date.
 */
export function handleEpoch(epoch: string) {
	let compDate: Date;

	const length = epoch.length;

	if (length === 10) {
		compDate = new Date(parseInt(epoch, 10) * 1000);
	} else if (length === 12 || length === 13) {
		compDate = new Date(parseInt(epoch, 10));
	} else {
		console.log('Bad EPOCH value: ', epoch);
		return null;
	}

	return compDate;
}

/**
 *   Used as a feed function for valid time period chunks in call to
 *   finansinspektionen (fetch 5 days at a time).
 */
export function getPeriodChunks(startDate: Date) {
	const todaysDate = new Date();
	const list = [];

	const iterationSize = 5;

	let next = startDate.valueOf() + iterationSize * 24 * 60 * 60 * 1000;
	let prev = startDate.valueOf();

	while (prev < todaysDate.valueOf()) {
		list.push({ from: shortDate(prev), to: shortDate(next) });
		prev = next + 1 * 24 * 60 * 60 * 1000;
		next = next + (iterationSize + 1) * 24 * 60 * 60 * 1000;
	}

	return list;
}

/**
 *   Get date from datetime.
 */
function shortDate(date: number | Date) {
	return new Date(date).toISOString().split('T')[0];
}

/**
 *  Turn a date and time (UTC -> UTC), epoch in seconds.
 */
export function makeEpoch(date: string, time: string) {
	const dateTime = new Date(`${date}T${time}`); // UTC -> UTC
	return dateTime.valueOf() / 1000;
}

/**
 *   Turn a GMT+2/+1 into UTC epoch.
 */
export function translateEpochUTC(epoch: string | number) {
	let date: Date | null;
	if (typeof epoch === 'string') {
		date = handleEpoch(epoch);
	} else {
		date = handleEpoch(epoch.toString());
	}

	if (date) {
		let updatedDate: Date;
		if (hasDST(date)) {
			updatedDate = new Date(date.valueOf() - 2 * 60 * 60 * 1000); // GMT+2 -> UTC
		} else {
			updatedDate = new Date(date.valueOf() - 1 * 60 * 60 * 1000); // GMT+1 -> UTC
		}
		return updatedDate.valueOf() / 1000;
	} else {
		return 0;
	}
}

/**
 *   Turn a UTC into a GMT+2/+1 epoch.
 */
export function translateEpochGMT(epoch: string | number) {
	let date: Date | null;

	if (typeof epoch === 'string') {
		date = handleEpoch(epoch);
	} else {
		date = handleEpoch(epoch.toString());
	}

	if (date) {
		let updatedDate: Date;
		if (hasDST(date)) {
			updatedDate = new Date(date.valueOf() + 2 * 60 * 60 * 1000); // UTC -> GMT+2
		} else {
			updatedDate = new Date(date.valueOf() + 1 * 60 * 60 * 1000); // UTC -> GMT+1
		}
		return updatedDate.valueOf() / 1000;
	} else {
		return 0;
	}
}
